import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_sample_data_for_adjustmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectIds?: number[] }): 
  Promise<{ result: { LotId?: number, LicensePlateId?: number, Lot?: { MaterialId?: number, Material?: { ProjectId?: number } }, LicensePlate?: { WarehouseId?: number } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { LotId?: number, LicensePlateId?: number, Lot?: { MaterialId?: number, Material?: { ProjectId?: number } }, LicensePlate?: { WarehouseId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectIds?: number[], $keys: { LotId?: number, LicensePlateId?: number, Lot?: { MaterialId?: number, Material?: { ProjectId?: number } }, LicensePlate?: { WarehouseId?: number } }[] }): 
  Promise<{ result: { LotId?: number, LicensePlateId?: number, Lot?: { MaterialId?: number, Material?: { ProjectId?: number } }, LicensePlate?: { WarehouseId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectIds?: number[]    }) {
      return false;
    }
}
